<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Nature of Injury :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link to="/incidents">
                            <i class="fa fa-stethoscope"></i> Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link to="/incidents/settings#injury_types">
                            Settings - Injury Types
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-edit"></i> Edit</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-7">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.TypeName }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Nature of Injury Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="TypeName" v-model="injury_type.TypeName" class="form-control" placeholder="Enter Nature of Injury Name" />
                                    <span v-if="errors.TypeName" class="text-danger">
                                        <span v-for="error in errors.TypeName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="injury_type.IsActive" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveInjuryType(this)" :disabled="saving">
                Save Nature of Injury
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                injury_type_id: this.$route.params.id,
                injury_type: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getInjuryType: function() {
                //Get the data
                this.$http
                    .get('admin/injury-types-edit' + (this.injury_type_id ? '/' + this.injury_type_id : ''))
                    .then(response => {
                        //Set all the data
                        this.injury_type = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveInjuryType: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/injury-types-edit' + (this.injury_type_id ? '/' + this.injury_type_id : ''), this.injury_type)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Nature of Injury Saved');

                    //Return to main list?
                    this.$router.push('/incidents/settings#injury_types');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the injuries
            this.getInjuryType();
        }
    }
</script>
